import Vue from 'vue';
import { getFromTemplate } from 'tools/getFromHtml';
import outlookCountrySearch from 'outlook/components/hubPage/countrySearch';

const countrySearchElement = document.querySelector('[data-vue-country-search]');
if (countrySearchElement) {
    new Vue({
        el: countrySearchElement,
        render(createElement) {
            return createElement(outlookCountrySearch, {
                props: {
                    marketData: JSON.parse(getFromTemplate('var', 'marketData')),
                    regions: JSON.parse(getFromTemplate('var', 'regions')),
                },
            });
        },
    });
}
